import slug from "slug";

export const orphans = () => {
    document.querySelectorAll("span, h2, h3, h1, p").forEach((span) => {
        let tekst = span.innerHTML;
        tekst = tekst.replace(/(\s)([^<,]{1,2})[\s]+/g, "$1$2&nbsp;");
        span.innerHTML = tekst;
    });
}

export const orphansDirect = (tekst) => {
    if (tekst) {

        tekst = tekst.toString().replace(/^([^<,]{2})[\s]+/g, "$1&nbsp;");
        tekst = tekst.toString().replace(/^([^<,]{1})[\s]+/g, "$1&nbsp;");
        tekst = tekst.toString().replace(/([^<,]{1})[\s]+/g, "$1&nbsp;");
        return tekst
    } else {
        return ''
    }
}

export function minHeight() {
    const headerElement = document.getElementsByTagName("header")[0];
    const footerElement = document.getElementsByTagName("footer")[0];
    const mainElement = document.getElementsByTagName("main")[0];

    if (!headerElement || !footerElement || !mainElement) {
        return
    }

    const headerH = headerElement.offsetHeight;
    const footerH = footerElement.offsetHeight;
    const takenH = headerH + footerH;

    mainElement.style.minHeight = `calc(100vh - ${takenH}px)`;
}

export const formatDate = (data) => {
    if (!data || typeof data !== "string") {
        return ""
    }

    const normalizedDate = data.split("T")[0]
    const dateParts = normalizedDate.split("-")

    if (dateParts.length !== 3) {
        return normalizedDate
    }

    return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`
}

export const formatDateComplex = (data) => {
    data = new Date(data)
    data = `${data.getDate()}.${data.getMonth() < 9 ? `0${data.getMonth() + 1}` : data.getMonth() + 1}.${data.getFullYear()}`
    return data
}

export const getYear = (data) => {
    data = new Date(data)
    data = `${data.getFullYear()}`
    return data
}

export const formatDateComplexYearMonthDay = (data) => {
    data = new Date(data)
    data = `${data.getFullYear()}-${data.getMonth() < 9 ? `0${data.getMonth() + 1}` : data.getMonth() + 1}-${data.getDate() < 10 ? `0${data.getDate()}` : data.getDate()}`
    return data
}

export const formatPhone = (data) => {
    if( data) {
        data = data.replace(/[() ]/g, "");
    }
    return data
}

export const adjustQueryParams = (name, value, type, queryParams) => {
    if (!value) {
        delete queryParams[name]
    } else {
        if (type === "string") {
            queryParams[name] = value
        } else if (type === "multiSelect") {
            if (value.length > 0) {
                queryParams[name] = value.toString()
            } else {
                delete queryParams[name]
            }
        } else {
            if (Array.isArray(queryParams[name])) {
                if (queryParams[name].includes(value)) {
                    queryParams[name].splice(queryParams[name].indexOf(value), 1)
                } else {
                    queryParams[name] = [...new Set([...queryParams[name], ...[value]])]
                }
            } else {
                if (queryParams[name] === value) {
                    queryParams[name] = ''
                } else {
                    queryParams[name] = queryParams[name] ? [queryParams[name], value] : [value]
                }
            }
        }
    }

    return queryParams
}

export const createLink = (params, start, discard) => {
    let link = start ? start : '?'

    discard = discard ? discard : []

    Object.keys(params).forEach(function (key, index) {

        if (!discard.includes(key)) {
            if (params[key]) {
                if (index !== 0) {
                    link = link + '&'
                }

                if (Array.isArray(params[key])) {
                    link = link + `${key}=${params[key].toString()}`
                } else {
                    link = link + `${key}=${params[key]}`
                }
            }
        }
    });

    return link
}

export const createParamsLink = (params, start, discard) => {
    let link = start ? start : '?'

    discard = discard ? discard : []

    Object.keys(params).forEach(function (key, index) {

        if (!discard.includes(key)) {
            if (params[key]) {
                if (index !== 0) {
                    link = link + '&'
                }

                if (Array.isArray(params[key])) {
                    params[key].forEach((item, index) => {
                        if (index !== 0) {
                            link = link + '&'
                        }

                        link = link + `${key}=${item}`
                    })
                } else {
                    link = link + `${key}=${params[key]}`
                }
            }
        }
    });

    return link
}

export const searchHandle = (name, value, type, location, history ,queryParams) => {
    const params = adjustQueryParams(name, value, type, queryParams)
    const link = createLink(params)

    history.push(location.pathname.slice(-1) !== '/' ? `${location.pathname}${link}` : `${location.pathname.slice(0, -1)}${link}`)
}

export const multipleParamsSearchHandle = (values, location, history, queryParams) => {

    let params = ''

    values.forEach((item) => {
        params = adjustQueryParams(item.name, item.value, item.type, queryParams)
    })

    const link = createLink(params)

    history.push(location.pathname.slice(-1) !== '/' ? `${location.pathname}${link}` : `${location.pathname.slice(0, -1)}${link}`)
}

export const sortAsc = (a, b) => {
    const ValueA = a.toLowerCase();
    const ValueB = b.toLowerCase();

    return ValueA.localeCompare(ValueB)
}

export const sortDesc = (a, b) => {
    const ValueA = a.toLowerCase();
    const ValueB = b.toLowerCase();

    return ValueB.localeCompare(ValueA)
}

export const getData = async (urlList) => {
    return await Promise.all(
        urlList.map((item) => fetch(item.url).then(res => res.json().then(json => {
            return {
                response : json,
                name : item.name
            }
        })))
    )
}

const createHttpError = (status, payload) => {
    const error = new Error(`HTTP ${status}`);
    error.status = status;
    error.payload = payload;
    return error;
}

export const fetchJson = async (url, options) => {
    const response = await fetch(url, options);
    let payload = null;

    try {
        payload = await response.json();
    } catch (error) {
        payload = null;
    }

    if (!response.ok) {
        throw createHttpError(response.status, payload);
    }

    return payload;
}

export const getDataOrThrow = async (urlList) => {
    return await Promise.all(
        urlList.map(async (item) => {
            return {
                response: await fetchJson(item.url),
                name: item.name
            }
        })
    )
}

export const isNotFoundError = (error) => {
    return error?.status === 404;
}

export const normalizeLang = (lang) => {
    return lang === "en" ? "en" : "pl";
}

export const getNotFoundPath = (lang) => {
    return `/${normalizeLang(lang)}/404`;
}

export const getNotFoundPathFromLocation = (pathname) => {
    const lang = pathname?.split('/')[1];
    return getNotFoundPath(lang);
}

export const stripHtml = (string) => {
    let div = document.createElement("div");
    div.innerHTML = string
    string = div.innerText
    return string
}

const biographyLabels = {
    pl: {
        1: "",
        2: "Biografia pełna",
    },
    en: {
        1: "",
        2: "Complete Biography",
    }
}

const getSlugValue = (value, allowHtml) => {
    if (typeof value !== "string") {
        return ""
    }

    const normalizedValue = allowHtml ? stripHtml(value) : value
    return slug(normalizedValue)
}

const getComposerSlugValue = (composer) => {
    if (!composer) {
        return ""
    }

    if (composer.first_name || composer.last_name) {
        return getSlugValue(`${composer.first_name ? composer.first_name : ""}-${composer.last_name ? composer.last_name : ""}`)
    }

    if (composer.composer) {
        return getSlugValue(composer.composer)
    }

    if (composer.name) {
        return getSlugValue(composer.name)
    }

    return ""
}

const createIdSlug = (id, slugValue) => {
    return slugValue ? `${id}-${slugValue}` : `${id}`
}

const getResourceId = (resource, fallbackId, candidateKeys) => {
    if (fallbackId !== undefined && fallbackId !== null && fallbackId !== "") {
        return fallbackId
    }

    if (!resource) {
        return null
    }

    for (const key of candidateKeys) {
        if (resource[key] !== undefined && resource[key] !== null && resource[key] !== "") {
            return resource[key]
        }
    }

    return null
}

export const buildComposerPath = (lang, composer) => {
    return `/${lang}/osoba/${createIdSlug(composer.id, getComposerSlugValue(composer))}`
}

export const buildComposerSectionPath = (lang, composer, section) => {
    return `${buildComposerPath(lang, composer)}/${section}`
}

export const buildComposerBiographyPath = (lang, composer, subId) => {
    const parsedSubId = parseInt(subId)

    if (parsedSubId === 1 || Number.isNaN(parsedSubId)) {
        return buildComposerPath(lang, composer)
    }

    const label = biographyLabels[lang]?.[parsedSubId]
    const suffix = label ? `-${getSlugValue(label)}` : ""

    return `${buildComposerPath(lang, composer)}/biografia/${parsedSubId}${suffix}`
}

export const buildComposerGenrePath = (lang, composer, genre) => {
    return `${buildComposerPath(lang, composer)}/gatunki/${createIdSlug(genre.id, getSlugValue(genre.name))}`
}

export const buildComposerCompositionPath = (lang, composer, composition) => {
    return `${buildComposerPath(lang, composer)}/kompozycje/${createIdSlug(composition.id, getSlugValue(composition.title, true))}`
}

export const buildComposerBibliographyPath = (lang, composer, bibliography) => {
    return `${buildComposerPath(lang, composer)}/bibliografia/${createIdSlug(bibliography.id, getSlugValue(bibliography.title, true))}`
}

export const buildComposerLetterPath = (lang, composer, letter) => {
    return `${buildComposerPath(lang, composer)}/list/${createIdSlug(letter.id, getSlugValue(letter.name, true))}`
}

export const buildComposerMultimediaPath = (lang, composer, type, subId) => {
    return `${buildComposerPath(lang, composer)}/multimedia/${type}/${subId}`
}

export const buildComposerManuscriptPath = (lang, composer, manuscript, compositionId) => {
    const suffix = compositionId ? `/${compositionId}` : ""
    return `${buildComposerPath(lang, composer)}/rekopisy/${createIdSlug(manuscript.id, getSlugValue(manuscript.title, true))}${suffix}`
}

export const buildArticlePath = (lang, article) => {
    return `/${lang}/artykuly/${createIdSlug(article.id, getSlugValue(article.title, true))}`
}

export const buildNewsPath = (lang, news, fallbackCategory, fallbackId) => {
    const category = news && news.category ? news.category : fallbackCategory
    const resolvedId = getResourceId(news, fallbackId, ["id", "news_id", "id_news", "newsId"])

    if (!category || resolvedId === null) {
        return null
    }

    return `/${lang}/aktualnosci/${category}/${createIdSlug(resolvedId, getSlugValue(news ? news.title : ""))}`
}

export const buildGenrePath = (lang, genre) => {
    return `/${lang}/gatunki/${createIdSlug(genre.id, getSlugValue(genre.name))}`
}

export const replaceWithCanonicalPath = (history, location, pathname) => {
    if (!pathname || pathname === location.pathname) {
        return
    }

    history.replace({
        pathname,
        search: location.search,
        hash: location.hash,
        state: location.state
    })
}
